import "./index.css";
import "./scripts/cleanUrl";
import "./scripts/tab_navigation";
import "./scripts/localstorage_seperator";
import "./scripts/url_param_handler";
import "./scripts/href_sort_interceptor";
import "./scripts/alpine_init_stores";
import "./scripts/injection-protector";

import.meta.glob("./*/**/*.css", { eager: true });
const scripts = import.meta.glob(
  [
    "./**/*.js",
    "!./main.js",
    "!./scripts/cleanUrl.js",
    "!./scripts/tab_navigation.js",
    "!./scripts/localstorage_seperator.js",
    "!./scripts/url_param_handler.js",
    "!./scripts/href_sort_interceptor.js",
    "!./scripts/alpine_init_stores.js",
    "!./scripts/injection-protector.js",
    "!**/*.test.js",
    "!**/*.spec.js",
  ],
  { eager: true },
);

console.log("Loaded JS files:", scripts);
console.log("All assets loaded!");
